import { useContext, useState } from 'react';
import { Paper, LinearProgress, TextField, Grid, IconButton, TablePagination } from '@material-ui/core';
import { CustomerRequestsContext } from '../CustomerRequestsContext';
import { NavContext, UserContext } from '../../../contexts';
import { RequestsList } from '../../../common'
import { ApplicationRoles, RequestStatus } from '../../../../helpers';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'hidden',
    },
    author: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    table: {

    },
    status: {
    },
    performance: {
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        width:"100%"
    },
    searchField:{
        float:"right",
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width:"100%"
    }
}));

export const RequestsTable = (props) => {
    const classes: any = useStyles();
    
    const {
        getCurrentLocation 
    } = useContext(NavContext);
    
    const {
        isUserInRole,
        userInfo,
        setDraftRequests,
        draftRequests
    } = useContext(UserContext);

    const { 
        state,        
        deleteDraftRequest,
        abortCustomerRequest,
        loadRequests,
        isSearching,
        isDeletingRequest,
        isAbortingRequest,
        loadInvolvedUsers,
        hasLodedInvolvedUsers,
        isLoadingInvolvedUsers,
        getInvolvedUsers
    } = useContext(CustomerRequestsContext);

    const [pageIndex, setPageIndex] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [searchText, setSearchText] = useState("")
    const [isSearchingMode, setIsSearchingMode] = useState(false) 
    
    const deleteRequestClickHanlder = async (request) => {
        if (request) {
            if (
                isUserInRole(ApplicationRoles.AOFOpener) &&
                request.status === RequestStatus.Draft &&
                request.ownerKey === userInfo.externalKey
            ){
                const success = await deleteDraftRequest(request.customerRequestId, request.dbType);

                if (success)
                    setDraftRequests(draftRequests - 1);
            }
            else if (isUserInRole(ApplicationRoles.Administrator))
                await abortCustomerRequest(request.customerRequestId, request.dbType);
        }
    };

    const canDelete = () => {
        const location = getCurrentLocation();
        return location.pathname.includes("/draft") || isUserInRole(ApplicationRoles.Administrator);
    };

    const isLoading = () => {
        return isSearching || isAbortingRequest || isDeletingRequest;
    };

    const getRequests = (text, pageIndex?, pageSize?) => {
        if (text && text !== "")
            setIsSearchingMode(true);
        else
            setIsSearchingMode(false);
            
        const location = getCurrentLocation();

        if (location.pathname.includes("/draft"))
            loadRequests("draft", text, pageIndex, pageSize);

        else if(location.pathname.includes("/running"))
            loadRequests("running", text, pageIndex, pageSize);

        else if(location.pathname.includes("/completed"))
            loadRequests("completed", text, pageIndex, pageSize);
    };

    const keyPressHandler = (e) => {
        if (e.key === 'Enter')
            getRequests(searchText);
    };

    const closeSearchHandler = () =>{
        setSearchText("");
        getRequests("", 0, pageSize);
    };

    const changePageHandeler = (event, newPage) => {
        setPageIndex(newPage);
        getRequests(searchText, newPage, pageSize);
    };

    const changePageSizeHandeler = event => {
        setPageSize(parseInt(event.target.value, 10));
        setPageIndex(0);
        getRequests(searchText, 0, event.target.value);
    };

    const showInChargeOf = () => {
        const location = getCurrentLocation();

        if (location.pathname.includes("/draft"))
            return false;

        else if(location.pathname.includes("/running"))
            return true;

        else if(location.pathname.includes("/completed"))
            return false;
    };
    
    return (        
        <>
            <Grid container>
                <Grid item xl={9}></Grid>
                <Grid item xl={3} xs={12}>
                    <Paper className={classes.searchField}>
                        <Grid spacing={2} container alignItems="center" justifyContent="space-between">
                            <Grid item xl={10} md={11} xs={10}>
                                <TextField
                                    onChange={(e) => setSearchText(e.target.value)}
                                    disabled={isLoading()}
                                    value={searchText}
                                    onKeyPress={(e) => keyPressHandler(e)}
                                    className={classes.input}
                                    placeholder="Search Requests"
                                    inputProps={{ 'aria-label': 'search request' }}
                                />
                            </Grid>
                            <Grid item xl={2} md={1} xs={2}>
                                {
                                    isSearchingMode &&
                                    <IconButton
                                        disabled={isLoading()}
                                        onClick={() => closeSearchHandler()}
                                        className={classes.iconButton} 
                                        aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                }

                                {
                                    !isSearchingMode &&
                                    <IconButton
                                        disabled={isLoading()}
                                        onClick={() => getRequests(searchText)}
                                        className={classes.iconButton} 
                                        aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                }
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            {
                isLoading() &&
                <LinearProgress color="primary" />
            }

            <Paper className={classes.root}>
                <TablePagination
                    rowsPerPageOptions={[10, 20, 30]}
                    component="div"
                    count={state.totalItems}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    onPageChange={changePageHandeler}
                    onRowsPerPageChange={changePageSizeHandeler}
                />
                <RequestsList
                    requestId
                    attachments
                    isDisabled={isLoading()}
                    delete={canDelete()}
                    deleteHandler={deleteRequestClickHanlder}
                    requests={state.requests}
                    inChargeOf={showInChargeOf()}
                    involvedUsers={{
                        hasLodedInvolvedUsers,
                        loadInvolvedUsers,
                        isLoadingInvolvedUsers,
                        getInvolvedUsers
                    }}
                />
            </Paper>        
        </>
    );
}